import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface TimeBasedSettingForSpecificCallerResponse extends MiddlewareAPIResponse
{
    
}

export class TimeBasedSettingForSpecificCallerResponseDtoImpl extends MiddlewareDtoImpl implements TimeBasedSettingForSpecificCallerResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforspecificcaller/timebasedsettingforspecificcallerresponse.tsx